import md5 from 'md5'
import { v4 as uuidv4 } from 'uuid'

import usersTable from './Users'
import printersTable from './Printers'
import usageTable from './Usage'
import managedTable from './Managed'
import clientsTable from './Clients'
import groupsTable from './Groups'
import policiesTable from './Policies'
import moment from 'moment'

const serviceUrl = 'https://api.maprinter.com/service'

export default {
  methods: {
    t (text) {
      if (text != null) {
        if (window.i18nJson == undefined) {
          window.i18nJson = {}
        }
        var lowerText = text.toString().toLowerCase()
        window.i18nJson['"' + lowerText + '"'] = ''
        var translated = this.$t(lowerText)
        if (translated == '' || translated == lowerText) {
          translated = text
        }
        return translated
      }
      return null
    },
    delay () {
      var timer = 0
      return function (callback, ms) {
        clearTimeout(timer)
        timer = setTimeout(callback, ms)
      }
    },
    usersTable,
    printersTable,
    usageTable,
    managedTable,
    clientsTable,
    groupsTable,
    policiesTable,
    createTableProperties: _this => {
      _this.uniqueColumns.unshift({})
      const columns = _this.uniqueColumns
      const options = $.extend(
        true,
        {
          stateSaveParams: (settings, data) => {
            delete data.order
            delete data.search
            for (var i = 0; i < data.columns.length; i++) { delete data.columns[i].search }
          }
        },
        _this.tableSettings(_this),
        { data: _this.data, columns }
      )
      if (_this.table) {
        _this.table.destroy()
        $(_this.$el)
          .find('table')
          .empty()
      }
      return { columns, options }
    },
    createEditor: (_this, fields, ajax) =>
      new $.fn.dataTable.Editor(
        $.extend({}, _this.editorSettings(_this), {
          table: $(_this.$el).find('table'),
          idSrc: 'DT_RowId',
          fields,
          ajax
        })
      ),
    createButtons: (_this, buttons1, buttons2) => {
      if (buttons1 && buttons1.length > 0) {
        new $.fn.dataTable.Buttons(_this.table, { buttons: buttons1 })
        const topButtonsContainerLeft = _this.table
          .buttons(1, null)
          .container()
          .addClass('dt-header-buttons left')
        topButtonsContainerLeft.prependTo(_this.table.table().container())
      }
      if (buttons2 && buttons2.length > 0) {
        new $.fn.dataTable.Buttons(_this.table, { buttons: buttons2 })
        const topButtonsContainerLeft = _this.table
          .buttons(2, null)
          .container()
          .addClass('dt-header-buttons right')
        topButtonsContainerLeft.prependTo(_this.table.table().container())
      }
    },
    clearData: _this => {
      _this.uniqueColumns = []
      _this.columns = []
      _this.data = []
    },
    downloadLink: id => {
      return `${serviceUrl}?request=download&user=${id}`
    },
    validClient: client => {
      return client.name.length > 0
    },
    md5: string => md5(string),
    uuidv4: () => uuidv4(),
    getUrlParameter: (sParam, url) => {
      let link = url ? new URL(url) : window.location
      let sPageURL = link.search.substring(1)
      let sURLVariables = sPageURL.split('&')
      let sParameterName, i

      for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=')

        if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined
            ? true
            : decodeURIComponent(sParameterName[1])
        }
      }
    },
    unique (array) {
      return $.grep(array, function (el, index) {
        return index == $.inArray(el, array)
      })
    },
    hashCode (str) {
      var hash = 0,
        i,
        chr
      if (str.length === 0) return hash
      for (i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i)
        hash = (hash << 5) - hash + chr
        hash |= 0
      }
      return hash
    },
    walker (obj, func) {
      var k
      var has = Object.prototype.hasOwnProperty.bind(obj)

      for (k in obj) {
        if (has(k)) {
          switch (typeof obj[k]) {
            case 'object':
              this.walker(obj[k], func)
              break
            case 'string':
              if (k != 'macAddress') {
                var hexVal = func(obj[k])
                if (isNaN(obj[k])) {
                  obj[k] = hexVal
                } else {
                  if (this.isASCII(func(obj[k], false))) {
                    obj[k] = hexVal
                  }
                }
              } else {
                obj[k] = obj[k].replace(/:/g, '').match(/.{1,2}/g).join(':')
              }
          }
        }
      }
    },
    isStringNumericalInteger (testValue) {
      return /^[\-+]?[1-9]{1}\d+$|^[\-+]?0$/.test(testValue.toString())
    },
    cleanseValue (val, removeASCII = true) {
      if (
        this.isHex(val) &&
        (!this.isStringNumericalInteger(val) ||
          Number(val) > 9223372036854775807 ||
          val.toString().length === 16)
      ) {
        return this.hex2str(val, removeASCII)
      }
      return val
    },
    isASCII (str) {
      return /^[\x00-\x7F]*$/.test(str)
    },
    isHex (str) {
      var regexp = /^[0-9a-fA-F]+$/
      if (regexp.test(str)) {
        return true
      } else {
        return false
      }
    },
    hex2str (hexx, removeASCII = true) {
      var hex = hexx.toString() // force conversion
      var str = ''
      for (var i = 0; i < hex.length; i += 2) { str += String.fromCharCode(parseInt(hex.substr(i, 2), 16)) }
      if (removeASCII) {
        str = str.replace(/[^ -~]/g, '')
      }
      return str
    },
    getUrlParam (key) {
      var url = new URL(window.location.href)
      var param = url.searchParams.get(key)
      if (param == null) return null
      const trimmed = String(param).trim()
      return trimmed.length > 0 ? trimmed : null
    },
    mdlCleanUp () {
      var mdlInputs = document.querySelectorAll('.mdl-js-textfield')
      for (var i = 0, l = mdlInputs.length; i < l; i++) {
        mdlInputs[i].MaterialTextfield.checkDirty()
      }
    },
    validateEmail (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    },
    colorToRGBA (color, alpha = 1) {
      var cvs, ctx
      cvs = document.createElement('canvas')
      cvs.height = 1
      cvs.width = 1
      ctx = cvs.getContext('2d')
      ctx.fillStyle = color
      ctx.fillRect(0, 0, 1, 1)
      var data = ctx.getImageData(0, 0, 1, 1).data
      var rgba =
        'rgba(' + data[0] + ',' + data[1] + ',' + data[2] + ',' + alpha + ')'
      return rgba
    },
    sanitizeName: name => {
      const exclusions = ['undefined']
      for (const exclusion of exclusions) {
        name = name.replace(new RegExp(exclusion, 'g'), '')
      }

      const withoutDuplications = name
        .split(' ')
        .filter(
          (item, i, allItems) =>
            i ==
            allItems.map(item => item.toLowerCase()).indexOf(item.toLowerCase())
        )

      const firstWordWithNumberIndex =
        withoutDuplications.findIndex(word => /\d/.test(word)) + 1

      const filteredName = withoutDuplications
        .slice(0, firstWordWithNumberIndex)
        .join(' ')
        .replace(/\s\s+/g, ' ')
        .trim()

      return filteredName
    },
    serviceRequest (request, data) {
      return new Promise(async (resolve, reject) => {
        $.ajax({
          url: `${serviceUrl}?request=${request}`,
          type: 'post',
          data: JSON.stringify(data),
          success: async response => {
            resolve(response)
          },
          error: (request, status, error) => {
            reject(error)
          }
        })
      })
    },
    tableName (name) {
      switch (name) {
        case 'computers':
          return 'client'
        case 'printers':
          return 'printer'
        case 'usage':
          return 'printer'
        case 'services':
          return 'printer'
        // case 'clients':
        //   return 'user'
        // case 'groups':
        //   return 'group'
        // case 'policies':
        //   return 'policy'
      }
    },
    tableSettings (_this) {
      const name = this.tableName(_this.id)
      const order = _this.id === 'computers' ? [[3, 'desc']] : [[1, 'desc']]
      const colReorder =
        _this.id === 'computers'
          ? { fixedColumnsLeft: 4 }
          : { fixedColumnsLeft: 3 }
      return {
        destroy: true,
        buttons: [
          {
            extend: 'colvis',
            text: _this.t('Column Visibility'),
            className: 'btn-secondary',
            fade: 0
          },
          {
            extend: 'collection',
            text: _this.t('Export'),
            className: 'export',
            fade: 0,
            buttons: [
              {
                text: _this.t('print'),
                extend: 'print',
                exportOptions: {
                  columns: ':visible',
                  format: {
                    body: function (data, row, column, node) {
                      // For downloadLink column, get the raw data instead of rendered HTML
                      if ($(node).hasClass('button')) {
                        const cellData = _this.table.cell(node).data()
                        return cellData || data
                      }
                      // Strip HTML for other columns
                      return $('<div>').html(data).text()
                    }
                  }
                },
                className: 'btn-secondary',
                customize: win => {
                  const $body = $(win.document.body)
                  const $table = $body.find('table')
                  $body.attr(
                    'style',
                    'overflow: hidden !important;visibility: visible !important;'
                  )
                  $body.find('h1').hide()
                  $table.attr('style', '-fs-table-paginate:paginate')
                  $table.find('thead').css('display', 'table-header-group')
                  $table
                    .find('th, td')
                    .attr(
                      'style',
                      'border: 1px solid lightgray;font-size: 13px;'
                    )
                  $table.find('.select-checkbox').hide()
                }
              },
              {
                text: _this.t('excel'),
                extend: 'excel',
                title: null,
                exportOptions: {
                  columns: ':visible:not(.select-checkbox)',
                  format: {
                    body: function (data, row, column, node) {
                      // For downloadLink column, get the raw data instead of rendered HTML
                      if ($(node).hasClass('button')) {
                        const cellData = _this.table.cell(node).data()
                        return cellData || data
                      }
                      // Strip HTML for other columns
                      return $('<div>').html(data).text()
                    }
                  }
                },
                className: 'btn-secondary',
                customizeData: data => {
                  const { body } = data
                  const exportedRows = []
                  _this.table
                    .rows({ search: 'applied' })
                    .every(function (rowIdx) {
                      exportedRows.push(
                        $.extend(
                          {},
                          this.cells(rowIdx, ':visible')
                            .data()
                            .toArray()
                        )
                      )
                    })
                  for (const rowIndex in body) {
                    const row = body[rowIndex]
                    let exportedRowValues = Object.values(
                      exportedRows[rowIndex]
                    )
                    if (exportedRowValues[0] === '') {
                      exportedRowValues = exportedRowValues.slice(1)
                    }
                    for (let i = 0; i < row.length; i++) {
                      const value = exportedRowValues[i]
                      if (
                        value &&
                        value.toString().length === 13 &&
                        value.toString().endsWith('000') &&
                        moment(value).format() !== 'Invalid date'
                      ) {
                        row[i] = moment(value).format('L HH:mm')
                      }
                    }
                  }
                  return data
                }
              }
            ]
          }
        ],
        language: {
          search: ``,
          searchPlaceholder: _this.t(`Search...`),
          zeroRecords: _this.t(`No ${name}s yet`),
          infoEmpty: _this.t(`0 ${name}s found`),
          info: _this.t(`Showing _START_ - _END_ of _TOTAL_ ${name}s`),
          infoFiltered: ``,
          select: {
            rows: {
              _: ``,
              1: ``
            }
          }
        },
        order,
        colReorder
      }
    },
    editorSettings (_this) {
      const name = this.tableName(_this.id)
      return {
        i18n: {
          create: {
            button: _this.t(`New`),
            title: _this.t(`Create new ${name}`),
            submit: _this.t(`Create`)
          },
          edit: {
            button: _this.t(`Edit`),
            title: _this.t(`Edit ${name}`),
            submit: _this.t(`Update`)
          },
          remove: {
            button: _this.t('Remove'),
            title: _this.t('Remove'),
            submit: _this.t('Delete'),
            confirm: {
              _: _this.t(`Are you sure you wish to delete %d ${name}s?`),
              1: _this.t(`Are you sure you wish to delete 1 ${name}?`)
            }
          },
          error: {
            system: _this.t(
              'An error has occurred, contact the system administrator'
            )
          }
        }
      }
    },
    arrayToObject (array, keyFields) {
      try {
        return array.reduce((obj, item) => {
          const key = keyFields.map(keyField => item[keyField]).join('/')
          obj[key] = item
          return obj
        }, {})
      } catch (e) {
        console.log(e)
        return {}
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Helpers.js